import React from "react";
import { Button } from "@glamcorner/components/lib/core/components/Button";
import { Header } from "@glamcorner/components/lib/core/components/Header";
import { SUBSCRIPTION_PLANS_STARTING } from "../../../constants";
import "./exclusive-subscription-only.scss";

export const ExclusiveSubscriptionOnly: React.FC = () => {
  return (
    <div className="c-exclusive-subscription-only">
      <Header as="h2" size="sm" withCloseButton={false}>
        Exclusive to GlamCorner Membership
      </Header>
      <div>
        Wear More and Spend Less with GlamCorner Membership. Monthly box of designer clothing delivered to your
        doorstep. Plans starting from ${SUBSCRIPTION_PLANS_STARTING}/month.
      </div>
      <Button href="/pages/membership" text="Learn more about GC Membership" />
    </div>
  );
};
